import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP3HighBudgetNew202506: FaireAdPerformancePeriodEntity = {
  token: "perf_p3_high_budget_new_202506",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-06-01",
  endDate: "2025-06-30",
  impressions: 3848,
  clicks: 93,
  adsSpendDollars: 292,
  budgetDollars: 1500,
  salesDollars: 18797,
  bestEstimateRoas: 64.37,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.19,
  newCustomersAcquired: 5,
  dataAvailableAtDate: "2025-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
